<template>
  <!-- 키워드 추가 입력 — 디자인 시스템 AppInput 사용. Enter 또는 우측 return 버튼으로 추가. -->
  <app-input v-model="inputWord" placeholder="키워드를 입력하세요" @enter="onAdd">
    <template #append>
      <button class="add-word-button" title="추가" @click="onAdd">
        <v-icon small>mdi-keyboard-return</v-icon>
      </button>
    </template>
  </app-input>
</template>

<script>
// TODO: 글자수 제한
export default {
  name: "KeywordInput",
  data() {
    return {
      inputWord: "",
    };
  },
  methods: {
    onAdd() {
      const word = (this.inputWord || "").trim();
      if (!word) return;
      this.$emit("add", word);
      this.inputWord = "";
    },
  },
};
</script>

<style scoped>
.add-word-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  cursor: pointer;
}
.add-word-button .v-icon {
  color: #8f7ddb !important;
}
.add-word-button:hover {
  background: rgba(145, 85, 253, 0.12);
}
</style>
